<template>
  <div>
    <router-view class="content" />
    <div class="row justify-content-center fixed-bottom navbar-container">
      <nav-bar />
    </div>
  </div>
</template>

<script>
import NavBar from "@/components/NavBar.vue";
export default {
  name: "MenuLayout",
  components: { NavBar },
  data() {
    return {};
  },
};
</script>

<style scoped>
.navbar-container {
  z-index: 5;
}

.content {
  margin-bottom: 70px;
}
</style>
